import { defineStore } from 'pinia';

export const useEnvPropsStore = defineStore('envProps', {
  state: () => ({
    headerContext: null,
    tokenizationPciIframeSrc: '',
    entryPoint: '',
    tagMngrEnv: '',
    navigationHostLink: '',
  }),
});
